import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './ls-hint-modal';

@customElement('ls-logout-hint-modal')
export class LsLogoutHintModal extends LitElement {
    static styles = css`
        .confirm-button {
            background-color: #00adee;
            color: #fff;
            border: none;
            padding: 10px 20px;
            border-radius: 3px;
            cursor: pointer;
        }

        .footer {
            display: flex;
            justify-content: end;
        }
    `;

    @property({ type: Function }) onConfirm: () => void = () => {};

    private autoLogoutTimer: number | null = null;

    connectedCallback() {
        super.connectedCallback();
        this.autoLogoutTimer = setTimeout(() => {
            this.onConfirm();
        }, 5000) as unknown as number;
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.autoLogoutTimer) {
            clearTimeout(this.autoLogoutTimer);
            this.autoLogoutTimer = null;
        }
    }

    private _confirmButtonClick = () => {
        if (this.autoLogoutTimer) {
            clearTimeout(this.autoLogoutTimer);
            this.autoLogoutTimer = null;
        }
        this.onConfirm();
    };

    render() {
        return html`<ls-hint-modal title="已登出帳號" .onClose=${this.onConfirm}>
            <div slot="content">
                為保障個資安全，您的登入已逾時並自動登出，<br />
                將於5秒後自動導向登入頁面。若您希望立即挑轉，請按下「確定」。
            </div>
            <div class="footer" slot="footer">
                <button class="confirm-button" @click=${this._confirmButtonClick}>確定</button>
            </div>
        </ls-hint-modal>`;
    }
}
